module.exports = __webpack_public_path__ + "assets/3d3b98401b39cdd99fd73918d7a768fd.mp4";